import { PatientRepository } from "@/domain/repository/patient-repository";
import { TerminateTreatmentUsecase } from "@/domain/usecase/doctor/treatment/terminate-treatment-usecase";
import { SATError, SATResult } from "@sadtx/sat-error";
import { CacheInvalidator } from "@/utils/cache/cache-invalidator";

export class DeactivatePatientUsecase {
  //MARK:- Constructor
  constructor(
    private readonly patientRepo: PatientRepository,
    private readonly terminateTreatmentUsecase: TerminateTreatmentUsecase,
    private readonly patientListCache?: CacheInvalidator
  ) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    treatmentUUIDsToCancel: string[]
  ): Promise<SATResult<void, SATError>> {
    // 진행 중·시작 전 치료가 있으면 먼저 순서대로 취소 (늦게 시작하는 치료부터 넘겨받음)
    if (treatmentUUIDsToCancel.length > 0) {
      const terminateResult =
        await this.terminateTreatmentUsecase.executeInOrder(treatmentUUIDsToCancel);

      // 처방 종료 실패 시 에러 반환 (환자는 비활성화하지 않음)
      if (terminateResult.isFailure) {
        return SATResult.failure(terminateResult.error);
      }
    }

    // 환자 비활성화
    const result = await this.patientRepo.deactivatePatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    // 환자 목록 캐시가 변경 전 데이터를 보여주지 않도록 비움
    this.patientListCache?.invalidate();
    return SATResult.success(void 0);
  }
}
